import { UserRole } from "../../generated/graphql";

const roleHebrewMap: Partial<Record<UserRole, string>> = {
  [UserRole.OrderModerator]: "מנהל הזמנות",
  [UserRole.OrderCreator]: "יוצר הזמנות",
  [UserRole.CatalogManager]: "מנהל קטלוג",
  [UserRole.SystemAdmin]: "מנהל מערכת",
  [UserRole.OrderModeratorLimited]: "מנהל הזמנות (מוגבל)",
  [UserRole.ClientUser]: "לקוח",
};

const getRoleLabel = (role?: UserRole): string | undefined =>
  role ? roleHebrewMap[role] : undefined;

export { roleHebrewMap, getRoleLabel };
